import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

// Scroll-triggered reveals (fire as the section enters the viewport).
export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "0px 0px -80px 0px" }}
    transition={{ duration: 0.8, delay, ease }}
  >
    {children}
  </motion.div>
);

export const RevealStagger = ({ children, className = "", stagger = 0.1 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "0px 0px -80px 0px" }}
    variants={{ show: { transition: { staggerChildren: stagger, delayChildren: 0.05 } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 32 }) => (
  <motion.div
    className={className}
    variants={{ hidden: { opacity: 0, y }, show: { opacity: 1, y: 0, transition: { duration: 0.7, ease } } }}
  >
    {children}
  </motion.div>
);
